// frontend/src/components/PageTransitionWrapper.js
import React from 'react';
import { useLocation } from 'react-router-dom'; // Importa useLocation

function PageTransitionWrapper({ children }) {
  const location = useLocation(); // useLocation ahora está dentro del contexto del Router

  return (
    // Envuelve el contenido (Routes) en un div con una clave que cambia con la ruta
    // para forzar la re-animación de la página al cambiar
    <div key={location.pathname} className="page-transition-container">
      {children}
    </div>
  );
}

export default PageTransitionWrapper;
